function isPlainObject(value: any): value is Record<string, any> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function deepMerge(target: Record<string, any>, source: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = { ...target };

  Object.keys(source).forEach((key) => {
    const sourceVal = source[key];
    const targetVal = result[key];

    if (isPlainObject(targetVal) && isPlainObject(sourceVal)) {
      // Recursively merge nested plain objects
      result[key] = deepMerge(targetVal, sourceVal);
    } else if (Array.isArray(sourceVal)) {
      // Replace arrays, but clone to avoid sharing references
      result[key] = [...sourceVal];
    } else if (isPlainObject(sourceVal)) {
      // Source is an object, target is not: create a new merged object branch
      result[key] = deepMerge({}, sourceVal);
    } else {
      // Primitive values or other types: simple replacement
      result[key] = sourceVal;
    }
  });

  return result;
}

export function mergeParams(params: Record<string, any>, attributes: Record<string, any> | undefined): Record<string, any> {
  if (!attributes) return params;
  return deepMerge(params, attributes);
}
